import {
  LocationQuestionConfig,
  LocationResponseState,
} from '@gripp/shared-logic';
import openMap from 'react-native-open-maps';
import { Text } from 'react-native-paper';
import { Link } from '../../../../crop-circle/Link';
import {
  ArrowTopRightAngleIcon,
  LocationIcon,
} from '../../../../crop-circle/icons';
import { RoutineQuestionMessage, RoutineQuestionMessageProps } from '../types';

export const LocationQuestionMessage: RoutineQuestionMessage<
  LocationQuestionConfig,
  LocationResponseState
> = (
  props: RoutineQuestionMessageProps<
    LocationQuestionConfig,
    LocationResponseState
  >
) => {
  const { response } = props;

  if (!response?.value) {
    return <Text style={props.textStyle}>—</Text>;
  }

  const handlePress = () => {
    const coordinates = response.coordinates;
    if (coordinates) {
      const [longitude, latitude] = coordinates;
      openMap({ query: `${latitude}, ${longitude}` });
    } else if (response.value) {
      openMap({ query: response.value });
    }
  };

  return (
    <Link
      children={response.value}
      underline={false}
      rightIcon={<ArrowTopRightAngleIcon size={12} />}
      leftIcon={<LocationIcon size={12} />}
      onPress={handlePress}
      emphasised={false}
      color="neutral"
      textStyle={{ fontWeight: '500' as const }}
      wrap
    />
  );
};
